import { Api } from '@/api';
import { Module } from 'vuex';
import { RootState } from '..';
import { User } from 'ignite360-core';

export interface AuthModuleState {
  authorization: string | null;
  user: User | null;
}

export function setAuthorization(authorization: AuthModuleState['authorization']) {
  authorization
    ? sessionStorage.setItem('authorization', authorization)
    : sessionStorage.removeItem('authorization');
  Api.setAuthorization(authorization);
}

export const AuthModule: Module<AuthModuleState, RootState> = {
  namespaced: true,
  state: {
    authorization: sessionStorage.getItem('authorization'),
    user: null,
  },
  getters: {
    isAuthenticated(state) {
      return !!state.user;
    },
    isImpersonating(state) {
      return !!state.user?.isImpersonating;
    },
  },
  mutations: {
    setAuthorization(state, authorization: AuthModuleState['authorization']) {
      setAuthorization(authorization);
      state.authorization = authorization;
    },

    setUser(state, user: AuthModuleState['user']) {
      state.user = user;
    },
  },
  actions: {
    async login(context, data: { email: string; password: string }) {
      await Api.login(data);
    },

    async logout(context) {
      context.commit('setUser', null);
    },

    async impersonate(context, userId: string) {
      const result = await Api.impersonate(userId);
      context.commit('setUser', result.data);
      await context.dispatch('bots/fetchAll', null, { root: true });
    },

    async stopImpersonation(context) {
      const result = await Api.stopImpersonation();
      context.commit('setUser', result.data);
      try {
        await context.dispatch('bots/fetchAll', null, { root: true });
      } catch (e) {
        // Session restore succeeded; project reload is best-effort
        console.error('Failed to reload bots after stopping impersonation', e);
      }
    },
  },
};
